import { RoutePaths } from '../constants/RoutePaths';

// Modified by AI on 05/13/2026. Edit #1.
export const getRouteWithParams = (route, params = {}) => Object.entries(params).reduce(
    (preparedRoute, [paramName, paramValue]) => preparedRoute.replace(`:${paramName}`, paramValue),
    route,
);

// Generated by AI on 05/13/2026
const getDefaultEmployerId = ({ user, employerRep, availableEmployerIds }) => {
    const sessionEmployerId = window.sessionStorage.getItem('positionListEmployerId');

    return employerRep?.employerId
        || sessionEmployerId
        || user?.origUserPrefs?.data?.lastSelectedEmployerId
        || user?.userPrefs?.lastSelectedEmployerId
        || availableEmployerIds?.[0]
        || null;
};

// Modified by AI on 05/13/2026. Edit #2.
export const getDefaultPostLoginRoute = ({ user, employerRep, availableEmployerIds }) => {
    const employerId = getDefaultEmployerId({ user, employerRep, availableEmployerIds });

    if (employerId) {
        return getRouteWithParams(RoutePaths.employerPositions, { employerId });
    }

    return null;
};
